import { render, staticRenderFns } from "./avgLoanRate.vue?vue&type=template&id=3c707d8f&scoped=true&"
import script from "./avgLoanRate.vue?vue&type=script&lang=js&"
export * from "./avgLoanRate.vue?vue&type=script&lang=js&"
import style0 from "./avgLoanRate.vue?vue&type=style&index=0&id=3c707d8f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c707d8f",
  null
  
)

export default component.exports